// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__PYclm","loader":"Loader_loader__sfSxd","loader_circle":"Loader_loader_circle__-KrWO","loader_animation":"Loader_loader_animation__TogcK"};